import React, { Component } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import Button from "components/UI/Button";
import { API_URL, ERROR_HANDLE, DOWNLOAD } from "config/constants";

/**
 * Custom workouts screen.
 * @param {*} props 
 * @returns 
 */
const Workouts = (props) => {

    const exportWorkouts = () => {
        const access_token = localStorage.getItem("access_token");
        const toastId = toast("Exporting...");
        axios
            .get(`${API_URL}/admin/export/completed_workouts`, {
                headers: {
                    "x-access-token": access_token
                }
            })
            .then(res => {
                DOWNLOAD(res.data, "workouts.csv");
                toast.dismiss(toastId);
            })
            .catch(err => {
                ERROR_HANDLE(err);
            });
    }

    return <div style={styles.wrapper}>
        <Button
            type="primary" style={styles.button}
            onClick={(e) => {
                e.stopPropagation()
                exportWorkouts();
            }}>Export Workouts</Button>
    </div>
}

const styles = {
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10px',
        flexDirection: 'column',
        alignItems: 'center'
    },
    button: {
        width: '250px',
        height: "50px",
        fontSize: "18px",
        marginLeft: "15px"
    },
};

export default Workouts;

